import { Button, Modal, Table, Tooltip } from 'antd';
import ModalInformationCategoryForm from 'components/ModalInformationCategoryForm';
import { useFormatMessage } from '../../hooks';
import paths from 'pages/Router/paths';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import { log } from 'utils';
// import Table from 'components/Table';
import {
  createInformationCategory,
  deleteInformationCategory,
  fetchInformationCategories,
  modifyInformationCategory,
} from 'state/actions/informationCategories';
import { regexInput } from 'utils/regex';
import './InformationCategories.scss';

const InformationCategories = () => {
  const { siteId } = useParams();

  const {
    informationCategoriesList,
    error,
    loading,
    deleted,
    userData,
    updated,
    role,
  } = useSelector(
    (state) => ({
      informationCategoriesList: state.informationCategories.list,
      error: state.informationCategories.error,
      loading: state.informationCategories.loading,
      deleted: state.informationCategories.deleted,
      userData: state.auth.userData,
      updated: state.informationCategories.updated,
      role: state.auth.userData.role,
    }),
    shallowEqual
  );

  if (informationCategoriesList) {
    log(informationCategoriesList, '<<<< information categories list');
  }

  const [deleteModal, setDeleteModal] = useState({
    categoryId: null,
    isOpen: false,
  });

  const defaultCategory = {
    name: '',
    description: '',
  };

  const dispatch = useDispatch();

  const [search, setSearch] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [visible, setVisible] = useState(false);
  const [category, setCategory] = useState(defaultCategory);
  const [searchError, setSearchError] = useState(null);

  const uid = userData.id;

  useEffect(() => {
    dispatch(fetchInformationCategories({ siteId }));
  }, [siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    log(updated);
    if (updated && !loading) {
      dispatch(fetchInformationCategories({ siteId }));
      setVisible(false);
    }
  }, [updated, loading]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (deleted && !loading) {
      setDeleteModal((prevState) => ({
        categoryId: null,
        isOpen: !prevState.isOpen,
      }));
      dispatch(fetchInformationCategories({ siteId }));
    }
  }, [deleted, loading]); // eslint-disable-line react-hooks/exhaustive-deps

  const redirect = !role && <Redirect to={paths.ROOT} />;

  const onCreate = (values) => {
    const action = isEditing
      ? modifyInformationCategory
      : createInformationCategory;

    dispatch(action({ uid, ...values, siteId }));
  };

  const onRemoveButtonClickHandler = (categoryId) => {
    setDeleteModal((prevState) => ({
      categoryId,
      isOpen: !prevState.isOpen,
    }));
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ categoryId: null, isOpen: false });
  };

  const onDeleteUserHandler = () => {
    dispatch(deleteInformationCategory(deleteModal.categoryId));
  };

  const onNewCategoryHandler = () => {
    setCategory(defaultCategory);
    setIsEditing(false);
    setVisible(true);
  };

  const handleSearch = (e) => {
    setSearchError(null);
    if (!regexInput(e.target.value) && e.target.value) {
      setSearchError('Search cannot using special character');
    }
    setSearch(e.target.value);
  };

  const columns = [
    {
      title: useFormatMessage('Categories.name'),
      dataIndex: 'name',
      sorter: {
        compare: (a, b) => a.name - b.name,
        multiple: 3,
      },
    },
    {
      title: useFormatMessage('Categories.description'),
      dataIndex: 'description',
      sorter: {
        compare: (a, b) => a.description - b.description,
        multiple: 2,
      },
    },
    {
      title: 'Option',
      dataIndex: 'option',

      render: (text, record) => (
        <div className="categories__actions">
          {role === 'superadmin' ? (
            <div className="buttons is-right">
              <Tooltip title="Edit Information Category">
                <button
                  data-tooltip="Edit"
                  onClick={() => {
                    setCategory(record);
                    setVisible(true);
                    setIsEditing(true);
                  }}
                  className="btn btn--edit"
                >
                  <i className="feather-edit" />
                </button>
              </Tooltip>

              <Tooltip title="Delete Information Category">
                <button
                  data-tooltip="Delete"
                  type="button"
                  className="btn btn--delete"
                  onClick={() => onRemoveButtonClickHandler(record._id)}
                >
                  <i className="feather-trash-2" />
                </button>
              </Tooltip>
            </div>
          ) : (
            <div className="buttons is-right">
              <Tooltip title="Edit Information Category">
                <button
                  disabled={true}
                  data-tooltip="Edit"
                  onClick={() => {}}
                  className="btn btn--edit"
                >
                  <i className="feather-edit" />
                </button>
              </Tooltip>

              <Tooltip title="Delete Information Category">
                <button
                  disabled={true}
                  data-tooltip="Delete"
                  type="button"
                  className="btn btn--delete"
                  onClick={() => null}
                >
                  <i className="feather-trash-2" />
                </button>
              </Tooltip>
            </div>
          )}
        </div>
      ),
    },
  ];

  const data = search
    ? informationCategoriesList.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name.toLowerCase().includes(search.toLowerCase());
      })
    : informationCategoriesList;

  const confirmMessage = useFormatMessage('Categories.confirm');

  const permDeleteMessage = useFormatMessage('Categories.permDelete');

  return (
    <section className="information-categories">
      {redirect}
      {deleteModal.isOpen && (
        <Modal
          title={confirmMessage}
          visible={deleteModal.isOpen}
          onOk={onDeleteUserHandler}
          onCancel={onCloseModalHandler}
        >
          {permDeleteMessage}
        </Modal>
      )}

      {visible && (
        <ModalInformationCategoryForm
          visible={true}
          onCancel={() => {
            setVisible(false);
          }}
          onCreate={onCreate}
          category={category}
          setCategory={setCategory}
          isEditing={isEditing}
        />
      )}
      <div className="categories__nav">
        <div className="categories__search-wrapper">
          <div className="categories__search">
            <i className="feather-search"></i>
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={handleSearch}
            />
          </div>
          {searchError && <div className="search-error">{searchError}</div>}
        </div>

        <Button
          type="primary"
          className="button-primary"
          onClick={onNewCategoryHandler}
        >
          {useFormatMessage('Categories.newCategory')}
        </Button>
      </div>

      <div className="categories__table">
        {loading ? (
          <ClipLoader />
        ) : (
          <Table columns={columns} dataSource={data} rowKey="_id" />
        )}
        {error && 'Show error'}
      </div>
    </section>
  );
};

export default InformationCategories;
